var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", [_vm._v("Login")]),
    _vm._v(" "),
    _c("form", { attrs: { action: "javascript:void(0);" } }, [
      _c("label", [_vm._v("Email Address:")]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.formEmail,
            expression: "formEmail"
          }
        ],
        attrs: { type: "text" },
        domProps: { value: _vm.formEmail },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.formEmail = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c("label", [_vm._v("Password:")]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.formPassword,
            expression: "formPassword"
          }
        ],
        attrs: { type: "password" },
        domProps: { value: _vm.formPassword },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.formPassword = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-secondary",
          on: {
            click: function($event) {
              _vm.login()
            }
          }
        },
        [_vm._v("Log In")]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.loginSuccess === false,
              expression: "loginSuccess===false"
            }
          ]
        },
        [_vm._v("Double check your email/password")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10d9df09", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10d9df09","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login.vue
// module id = 6Mk+
// module chunks = 1